var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{style:({ height: _vm.viewportHeight }),attrs:{"id":"iframe","src":_vm.url}})
}
var staticRenderFns = []

export { render, staticRenderFns }